import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-me-perfil-inserir',
  templateUrl: './me-perfil-inserir.component.html',
  styleUrls: ['./me-perfil-inserir.component.css']
})
export class MePerfilInserirComponent implements OnInit, OnDestroy {
  @ViewChild("capfoto") capfoto: ElementRef;
  @ViewChild("capfoto2") capfoto2: ElementRef;
  @ViewChild("uploader") meuUploader: ElementRef;
  @ViewChild("uploader2") meuUploader2: ElementRef;
  hideCL: boolean = false;
  tipoAdd: any = '';
  listaModalidades: any[] = [];
  imageChangedEvent: any = '';
  imageChangedEvent2: any = '';
  croppedImage: any = '';
  croppedImage2: any = '';
  myControl = new FormControl();
  //options: string[] = ['São Silvestre 2018', 'Corrida Integração 2019', 'Three'];
  options: any[] = [];
  filteredOptions: Observable<string[]>;
  qModalidade: any = '';
  qColocacao: any = '';
  competicao: any = '';
  linkfonte: any = '';
  comentario: any = '';
  canvasRotation: any = 0;
  canvasRotation2: any = 0;
  qGNivel: any = '';
  graduacaoCurso: any = '';
  graduacaoInstituicao: any = '';
  graduacaoAno: any = '';
  extimeline: boolean = true;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService, public dialog : MatDialog) { }

  ngOnInit() {
    
    //cria method para carregar as competições parceiras e tal
    // this.options.push({tag: '@sãosilvestre', nome: 'São Silvestre'},
    // {tag: '@strikeforce', nome: 'Strikeforce'},
    //  {tag: '@corridaintegração', nome: 'Corrida Integração'}, {tag: '@letour', nome: 'Tour de France'});
    
    //this.listaModalidades.push({id: 1, nome: 'Futebol', checked: true, disab: true}, {id: 2, nome: 'Rugby', checked: false, disab: false}, {id: 3, nome: 'MMA', checked: false, disab: false}, {id: 4, nome: 'Jiu Jitsu', checked: false, disab: false})
    // this.hideCL = true;
    console.log(this.tmaService.gUrlAnterior);
    const tipoAdd = this.route.snapshot.paramMap.get('tipoadd');
    this.tipoAdd = tipoAdd;
    if(tipoAdd == 'modalidades' ){
      console.log(tipoAdd);
      this.preModalidades();
    }
    else if(tipoAdd == 'conquistas'){
      console.log(tipoAdd);
      this.tmaService.eventoFS(true);
      this.carregarCompeticoes();
    }
    else if(tipoAdd == 'titulos'){
      this.hideCL = true;
      this.tmaService.eventoFS(true);
    }
    else if (tipoAdd == 'new'){
      console.log(tipoAdd);
    }
    else{
      this.router.navigate(["/me/perfil"]);
    }
  }

  carregarCompeticoes() :void{
    this.tmaService.listaBaseCompeticoes()
    .subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.options = qRes['arrCompeticoes'];
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(val => val.length >= 1 ? this._filter(val): [])
        );
        this.carregarModalidades();
      }
    })
  }

  preModalidades(): void{
    this.hideCL = false;
    if(!this.tmaService.mModLoaded){
      //acessou direto, carregar minhas modalidades
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&usuario=' + this.tmaService.hcNomeUsuario + '&tipodado=modalidades&meuindex=0';
      this.tmaService.listarDadosPerfil(dadosIn)
      .subscribe((qRes) =>{
        console.log(qRes);
        if(qRes['res'] == 'done'){
            this.tmaService.mModalidades = qRes['arrResultado'];
            this.tmaService.mModLoaded = true;
            this.carregarModalidades();
        }
        else{
          this.carregarModalidades();
        }
      })
    }
    else{
      this.carregarModalidades();
    }
  }
  carregarModalidades() :void{
    
    this.tmaService.listaBaseModalidades()
    .subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.listaModalidades = qRes['arrModalidades'];
        this.listaModalidades.forEach((qItem, index) => {
          if(this.tmaService.mModalidades.find(x => x.modalidade == qItem.modalidade)){
            this.listaModalidades[index].ck = true;
            this.listaModalidades[index].existia = true;
          }
          else{
            this.listaModalidades[index].existia = false;
          }
        });
      }
      this.hideCL = true;
      console.log("minhas modalidades");
      console.log(this.listaModalidades);
    })
  }

  ngOnDestroy(){
    console.log("destroy");
    
    this.tmaService.eventoFS(false);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.nome.toLowerCase().indexOf(filterValue) === 0);
  }

  altcheckMod(index, statusatual, exist):void{
    if(!exist){
      // console.log(index + " - " + statusatual);
      // console.log(this.listaModalidades[index].ck);
      this.listaModalidades[index].ck = !statusatual;
      // console.log(this.listaModalidades);
    }
    
  }
uploadFile($event) {
  console.log($event.target.files[0]); // outputs the first file
}

fileChangeEvent(event: any): void {

  this.imageChangedEvent = event;
  var formatoArq = this.imageChangedEvent.target.files[0].type;
  if(formatoArq.indexOf('video') != -1){
    this.croppedImage = '';
    this.meuUploader.nativeElement.value = '';
    const notVideoAllowed = this.dialog.open(AlertaSimplesDialog, {
      width: '300px',
      data: {  iconAlerta: 'warning', tituloAlerta: "Aviso", textoAlerta: "Formato incorreto.<br>Apenas fotos são permitidas.", textoConfirm: "Ok" }
    });
    return;
  }
  else{
    if(this.imageChangedEvent.target.files.length == 0){
      this.croppedImage = '';
      console.log("just clear");
    }
    else{
      this.hideCL = false;
      console.log("teste");
    }
  }
  
  
}

rotacionarImg() :void{
  console.log("girando");
  this.canvasRotation--;
  
  this.hideCL = false;
  setTimeout(() => {
    this.hideCL = true;
  }, 1500);
}

  imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = event.base64;
      console.log(this.croppedImage);
      //console.log(this.croppedImage);
  }
  imageLoaded() {
      // show cropper
      
  }
  cropperReady() {
      // cropper ready
      this.hideCL = true;
      this.capfoto.nativeElement.scrollIntoView();
  }
  loadImageFailed() {
      // show message
      console.log("failed");
      this.hideCL = true;
  }

  uploadFile2($event) {
    console.log($event.target.files[0]); // outputs the first file
  }
  
  fileChangeEvent2(event: any): void {
  
    this.imageChangedEvent2 = event;
    var formatoArq = this.imageChangedEvent2.target.files[0].type;

    if(formatoArq.indexOf('video') != -1){
      this.croppedImage = '';
      this.meuUploader2.nativeElement.value = '';
      const notVideoAllowed = this.dialog.open(AlertaSimplesDialog, {
        width: '300px',
        data: {  iconAlerta: 'warning', tituloAlerta: "Aviso", textoAlerta: "Formato incorreto.<br>Apenas fotos são permitidas.", textoConfirm: "Ok" }
      });
      return;
    }
    else{
      if(this.imageChangedEvent2.target.files.length == 0){
        this.croppedImage2 = '';
        console.log("just clear");
      }
      else{
        this.hideCL = false;
        console.log("teste");
      }
    }

    
    
  }
  
  rotacionarImg2() :void{
    console.log("girando");
    this.canvasRotation2--;
    this.hideCL = false;
    setTimeout(() => {
      this.hideCL = true;
    }, 1500);
  }
  
    imageCropped2(event: ImageCroppedEvent) {
        this.croppedImage2 = event.base64;
        console.log(this.croppedImage2);
        //console.log(this.croppedImage);
    }
    imageLoaded2() {
        // show cropper
        
    }
    cropperReady2() {
        // cropper ready
        this.hideCL = true;
        this.capfoto2.nativeElement.scrollIntoView();
    }
    loadImageFailed2() {
        // show message
        console.log("failed");
        this.hideCL = true;
    }

  salvar() :void{
    console.log("salvando");
   
    if(this.tipoAdd == 'modalidades'){
      this.hideCL = false;
      //percorrer todos pra identificar selecionados
      var modCheck = [] ;
      this.listaModalidades.forEach((qItem, index) => {
        if(qItem.ck == true && qItem.existia == false){
          modCheck.push(this.listaModalidades[index]);
        }
      });
      var meuArray = JSON.stringify(modCheck);
      let customParams = {
       //lista: localStorage.getItem('turboCart'),
       email: this.tmaService.hcEmail,
       senha: this.tmaService.hcSenha,
       arrModalidades: meuArray
    };
      this.tmaService.salvarModal(customParams)
      .subscribe((qDados) =>{
        console.log(qDados);
        this.hideCL = true;
        //após salvar, faz o redirect
        if(qDados['res'] == 'done'){
          this.voltar(); 
        }
        else{
          //erro
        }
      })
    }
    if(this.tipoAdd == 'conquistas'){
      console.log(this.extimeline);
      console.log(this.qModalidade);
      if(this.qModalidade == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor informe a modalidade", iconAlerta: 'warning' }
        })
        return;
      }
      if(this.qColocacao == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor informe a sua colocação nesta competição", iconAlerta: 'warning' }
        })
        return;
      }
      if(this.competicao == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Por favor informe a competição", iconAlerta: 'warning' }
        })
        return;
      }

      if(this.comentario == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Faça uma pequena descrição de como foi essa competição para você", iconAlerta: 'warning' }
        })
        return;
      }

      if(this.croppedImage == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você precisa adicionar uma foto para cadastrar essa conquista", iconAlerta: 'warning' }
        })
        return;
      }

      this.hideCL = false;
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        desempenho: this.qColocacao,
        competicao: this.competicao,
        linkreferencia: this.linkfonte,
        modalidade: this.qModalidade,
        fotoBase: encodeURI(this.croppedImage),
        comentario: this.comentario,
        copiafeed: this.extimeline
     };
       this.tmaService.salvarConquista(customParams)
       .subscribe((qDados) =>{
         console.log(qDados);
         this.hideCL = true;
         //após salvar, faz o redirect
         if(qDados['res'] == 'done'){
           this.voltar(); 
         }
         else{
           //erro
         }
       })
    }


    if(this.tipoAdd == 'titulos'){
      console.log("titulos");
      if(this.qGNivel == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve escolher o nível do título!", iconAlerta: 'warning' }
        })
  
        return;
      }

      if(this.graduacaoCurso == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve informar o nome do curso!", iconAlerta: 'warning' }
        })
  
        return;
      }
      if(this.graduacaoInstituicao == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve informar a instituição", iconAlerta: 'warning' }
        })
  
        return;
      }


      if(this.graduacaoAno == ''){
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Você deve informar o ano de conclusão", iconAlerta: 'warning' }
        })
  
        return;
      }

      this.hideCL = false;
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        nivel: this.qGNivel,
        curso: this.graduacaoCurso,
        instituicao: this.graduacaoInstituicao,
        ano: this.graduacaoAno,
        fotoBase: encodeURI(this.croppedImage2)
     };
       this.tmaService.salvarTitulo(customParams)
       .subscribe((qDados) =>{
         console.log(qDados);
         this.hideCL = true;
         //após salvar, faz o redirect
         if(qDados['res'] == 'done'){
           this.voltar(); 
         }
         else{
           //erro
         }
       })
    }
  }

  voltar() :void{
    //this.router.navigate(["/me/perfil/editar/" + this.tipoAdd]);
    this.router.navigate([ '/' + this.route.snapshot.paramMap.get('nomeusuario') + '/' + this.tipoAdd]);
    //this._location.back();
  }


}
